var _path, _g, _rect, _rect2, _rect3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSectionIcon2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 63,
    viewBox: "0 0 56 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.800049 8C0.800049 3.58172 4.38177 0 8.80005 0H35.66L42.8 7.14L51.2001 15.54V55C51.2001 59.4183 47.6183 63 43.2001 63H8.80005C4.38177 63 0.800049 59.4183 0.800049 55V8Z",
    fill: "url(#paint0_linear_840_3226)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_840_3226)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.4064 9.63786L35.66 0L51.2 15.54L41.5621 15.7936C38.1256 15.8841 35.3159 13.0744 35.4064 9.63786Z",
    fill: "url(#paint1_linear_840_3226)"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 7.52002,
    y: 42,
    width: 21,
    height: 2.52,
    rx: 1.26,
    fill: "#97D1FF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 7.52002,
    y: 47.8799,
    width: 36.96,
    height: 2.52,
    rx: 1.26,
    fill: "#97D1FF"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 7.52002,
    y: 53.76,
    width: 36.96,
    height: 2.52,
    rx: 1.26,
    fill: "#97D1FF"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_840_3226",
    x: 31.4043,
    y: 0,
    width: 23.7957,
    height: 23.7957,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_840_3226"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_840_3226",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_840_3226",
    x1: 0.800049,
    y1: 35.28,
    x2: 51.2001,
    y2: 35.28,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5B95DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00151691,
    stopColor: "#5B95DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00699072,
    stopColor: "#C9E1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0399991,
    stopColor: "#5B95DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B95DE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_840_3226",
    x1: 36.534,
    y1: 15.5286,
    x2: 45.74,
    y2: 7.14,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.668556,
    stopColor: "#E3F0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B95DE"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSectionIcon2);
export default __webpack_public_path__ + "static/media/section-icon-2.cfd7425467fa715f5fa545a977a49730.svg";
export { ForwardRef as ReactComponent };